import { Box, BoxProps, Space, Text } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";

export interface FieldCaptionProps extends BoxProps {
  label: string;
}

/**
 * Captions a field without being a <label>.
 *
 * Label renders a real <label>, which forwards clicks to the control inside
 * it. That is what you want on a field that owns its own input, and what
 * you do not want where the caption sits above something that handles its
 * own clicks, or above more than one control - see [[FieldGroupCaption]].
 *
 * Box props pass through, so a caption can be given the width the field
 * under it needs.
 */
export const FieldCaption: React.FC<FieldCaptionProps> = ({
  label,
  children,
  ...boxProps
}) => (
  <Box {...boxProps}>
    <Text
      variant={"bold"}
      size={"small"}
      color={cssColor("--tjara")}
      whiteSpace={"nowrap"}
    >
      {label}
    </Text>
    <Space />
    {children}
  </Box>
);
